module.exports = __webpack_public_path__ + "static/media/pin_users (3).017a6b8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pin_users (3).svg
// module id = 670
// module chunks = 0